import * as THREE from 'three'
import gsap from 'gsap'
import { BUILDING_TYPES, UNIT_TYPES } from '../Game/definitions.js'

export default class BuildingIndicator
{
    constructor(_options)
    {
        this.building = _options.building
        this.container = new THREE.Group()
        this.container.position.set(this.building.x, this.building.y, 3.6)
        this.dismissed = false
        const definition = BUILDING_TYPES[this.building.type]
        const resources = definition.kind === 'processor' ? [definition.input, definition.output] : Object.keys(UNIT_TYPES[definition.units[0]].recipe).slice(0, 3)
        resources.forEach((_resource, _index) =>
        {
            const item = _options.factory.createItem(_resource, 1.6)
            item.position.x = (_index - (resources.length - 1) * 0.5) * 0.85
            this.container.add(item)
        })
        if(definition.kind === 'processor')
        {
            const arrow = new THREE.Mesh(new THREE.ConeGeometry(0.18, 0.4, 8), new THREE.MeshBasicMaterial({ color: '#7cffaa' }))
            arrow.rotation.z = - Math.PI * 0.5
            this.container.add(arrow)
        }
    }

    update(_elapsed)
    {
        if(!this.dismissed)
            this.container.position.z = 3.6 + Math.sin(_elapsed * 0.004) * 0.18
    }

    dismiss()
    {
        if(this.dismissed)
            return
        this.dismissed = true
        gsap.to(this.container.scale, { x: 0, y: 0, z: 0, duration: 0.5, onComplete: () => this.container.visible = false })
    }
}
